import FlowScreens from 'core/common/components/FlowScreens';
import { FlowScreens as RedesignFlowScreens } from 'core/common/ui/pages';
import { FeatureFlagsConfig } from 'core/feature-flags/entities';
import { FlowProvider, FunnelProvider } from 'core/funnel/contexts';
import { FunnelConfig } from 'core/funnel/entities';
import { useFunnelConfig } from 'core/funnel/hooks';

export type FunnelProps = {
  screenId: string;
  isRedesignFlow?: boolean;
  funnelConfig: FunnelConfig | null;
  features: FeatureFlagsConfig['features'];
};

const Funnel = ({ screenId, features, funnelConfig, isRedesignFlow = false }: FunnelProps) => {
  const { config } = useFunnelConfig(funnelConfig);

  if (!config) {
    return null;
  }

  return (
    <FunnelProvider features={features} resources={config}>
      <FlowProvider>
        {isRedesignFlow ? (
          <RedesignFlowScreens screenId={screenId} />
        ) : (
          <FlowScreens pageId={screenId} />
        )}
      </FlowProvider>
    </FunnelProvider>
  );
};

export default Funnel;
